import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import BcpTile from '../components/Succession/BcpTile';
import BcpTileFallback from '../components/Succession/BcpTileFallback';
import ErrorBoundary from '../components/ErrorBoundary';

const GET_BCP_STATUS = gql`
  query {
    bcpFormDatum {
      id
      status
      completionPercentage
      currentSectionName
    }
  }
`;

const BcpTileContainer = () => {
  return (
    <ErrorBoundary fallback={<BcpTileFallback />}>
      <Query query={GET_BCP_STATUS}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div 
                className="shadow rounded-lg p-6 animate-pulse transition-colors duration-300"
                style={{
                  backgroundColor: 'var(--succession-bg-primary, #ffffff)',
                  border: '1px solid var(--succession-border, #e5e7eb)',
                  boxShadow: 'var(--succession-shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1))'
                }}
              >
                <div 
                  className="h-6 rounded w-3/4 mb-4"
                  style={{ backgroundColor: 'var(--succession-bg-tertiary, #e5e7eb)' }}
                ></div>
                <div 
                  className="h-32 rounded mb-4"
                  style={{ backgroundColor: 'var(--succession-bg-secondary, #f9fafb)' }}
                ></div>
                <div 
                  className="h-10 rounded w-1/2"
                  style={{ backgroundColor: 'var(--succession-bg-tertiary, #e5e7eb)' }}
                ></div>
              </div>
            );
          }
          
          if (error) {
            console.error('BCP data fetch error:', error);
            return <BcpTileFallback />;
          }
          
          const bcpData = {
            status: data?.bcpFormDatum?.status || 'not_started',
            completionPercentage: data?.bcpFormDatum?.completionPercentage || 0,
            currentSection: data?.bcpFormDatum?.currentSectionName || ''
          };
          
          return <BcpTile bcpData={bcpData} />;
        }}
      </Query>
    </ErrorBoundary>
  );
};

export default BcpTileContainer; 